import { render, staticRenderFns } from "./CampaignFunnel.vue?vue&type=template&id=bb848e58&scoped=true"
import script from "./CampaignFunnel.vue?vue&type=script&lang=js"
export * from "./CampaignFunnel.vue?vue&type=script&lang=js"
import style0 from "./CampaignFunnel.vue?vue&type=style&index=0&id=bb848e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb848e58",
  null
  
)

export default component.exports